// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","sliderImage":"Hero_sliderImage__lO0dJ","sliderContainer":"Hero_sliderContainer__Cgla-"};